<template>
  <div class="bg-white max-sm:px-4 border w-full">
    <TsRow class="sm:px-7 sm:py-3 max-sm:pt-6 max-sm:pb-4">
      <TsRow class="gap-2 m-0">
        <TsIcon
          @click="hideMenuDrawer"
          name="iconamoon:arrow-left-2-duotone"
          color="#666666"
          size="2rem"
          class="cursor-pointer text-secondary-black"
        />

        <TsTypography
          appendClass="mb-0 block text-base md:text-2xl font-bold
        text-black text-secondary-black sm:hidden"
          :text="
            useTranslation(
              'topBrandMenuText',
              'Upgrade uw gereedschapskist: koop premium topmerken!'
            )
          "
        />
        <TsTitle as="base"
          appendClass="mb-0 text-base md:text-2xl font-semibold text-black text-secondary-black hidden sm:block"
          data-testid="top-brand-menu-header"
          :title="
            useTranslation(
              'topBrandMenuText',
              'Upgrade uw gereedschapskist: koop premium topmerken!'
            )
          "
        />
      </TsRow>
    </TsRow>

    <TsRow
      appendClass="flex justify-center align-center mt-2 sm:mt-3 w-full"
    >
      <TsColumn class="max-sm:p-0 max-sm:is-12 sm:min-w-max justify-center">
        <div v-if="builderStore.brand_list_state.status === 'loading'">
          <TsBrandTransition />
        </div>
        <div v-if="builderStore.brand_list_state.status === 'failed'">
          Failed to fetch brands
        </div>
        <div v-if="builderStore.brand_list_state.status === 'success'">
        <TsGrid
          :cols="4"
          :rows="3"
          :space="3"
          class="px-1 sm:mx-2 m-0 md:ml-10"
          :mobileCols="2"
          :mobileRows="4"
          v-if="builderStore.builderBrands"
        > 
          <div
            class="h-full"
            v-for="brand in builderStore.builderBrands.slice(0, 10)"
            :key="brand.brand.id"
          >
            <NuxtLinkWithLocale
              :to="getBrandSlug(brand.brand.title,)"
              @click="handleImageLinkClick"
              :data-testid="`brand-menu-link-to-brands-${brand.brand.title.toLowerCase()}`"
              class="rounded-md block h-full"
              v-if="brand.brand.isTop"
            >
              <TsImage
                class="cursor-pointer max-sm:w-full"
                width="173"
                height="51"
                :data-testid="`brand-menu-image-of-${brand.brand.title.toLowerCase()}`"
                placeholder=""
                v-if="brand.brand.image"
                :src="`${brand.brand.image}?format=webp`"
                :alt="brand.brand.title"
              />
            </NuxtLinkWithLocale>
          </div>
        </TsGrid>
      </div>
      </TsColumn>
      <TsColumn class="max-sm:is-5 max-w-max hidden sm:flex">
        <TsImage
          class="rounded-md"
          src="/images/brand-banner.webp"
          alt="brandBannerImg"
          width="428"
          height="217"
          loading="lazy"
        />
      </TsColumn>
    </TsRow>
    <TsRow isCentered class="sm:w-[50rem] py-3">
      <NuxtLinkWithLocale
        class="text-primary text-base font-semibold underline"
        data-testid="link-to-brand-listing-page"
        :to="getBrandSlug()"
        >{{ useTranslation("viewAll", "Bekijk alles") }}
        </NuxtLinkWithLocale>
    </TsRow>
  </div>
</template>

<script setup lang="ts">
import { EventConstants } from '~/assets/constants/ecomApi';

const authStore = useAuthStore();
const rootStore = useRootStore();
const branchStore = useBranchStore();
const route = useRoute();

const TsBrandTransition = defineAsyncComponent(
    () => import('~/components/organisms/TsBrandTransition.vue')
);

const TsGrid = defineAsyncComponent(
    () => import('~/components/organisms/TsGrid.vue')
);


const builderStore = useBuilderStore();

const localepath = useLocalePath();

const emit = defineEmits(["onClose"]);

function hideMenuDrawer() {
  emit("onClose");
}

function handleImageLinkClick()
{
  const user = authStore.user;
  emit('onClose');
  logEvent({
    options: {
      eventAction: "click",
      eventProperties: {
        user: authStore.is_authenticated
                ? {
                    user_id: user.id,
                    email: user.email,
                    phone: user.mobile,
                    order_count: user.order_count,
                    order_value: user.order_value,
                    account_type: user.account_type,
                  }
                : "User is not Logged In",
                    page: {
              page_url: window.location.href,
              page_path: route.fullPath,
              page_referrer: document.referrer,
              page_title: document.title,
              content_group: "",
              content_group2: "",
            },
              site: {
                shop_language: "",
                shop_currency: EventConstants.currency,
                tax_toggle: rootStore.isIncVat ? "INC" : "EX",
                selected_branche: branchStore.currentSavedBranch?.id,
              },
      },
      eventInteraction: true,
      eventLabel: `brand_navigation`,
      eventName: "brand_navigation",
    },
  });
}
</script>
